import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { addStartAnimationToSprite } from '../AnimationManager';
import gameData, { GAME_IMAGES_KEY } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import IntroScreenBase from './IntroScreenBase';
import ABCyaLib from '@abcya/abcya_lib';

export default class TitleScreenBase extends Phaser.Scene {
  static get KEY() { return 'TitleScreen'; }

  constructor() {
    super({ key: TitleScreenBase.KEY });
  }

  init() {
    this.titleHeader = null;
    this.titleHeader1 = null;
    this.titleHeader2 = null;

    this.titleStamp = null;

    this.btnOptions = null;
    this.btnContainer = null;
  }

  create() {
    this.bg = ABCyaPhaser.Images.addImage(0,0, 'MainBackground', this, GAME_IMAGES_KEY).setOrigin(0);

    if (ABCyaLib.Environment.instance.gameConfig.playSubtitle) {
      ABCyaPhaser.Audio.playOneShot('number_ninja_title', this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }
    else {
      ABCyaPhaser.Audio.playOneShot('number_ninja_no_subtitle', this,1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }

    /** @type {Phaser.GameObjects.Image[]} */
    this.btnOptions = [];

    this.titleHeader = this.add.container(0,80);

    this.titleHeader1 = ABCyaPhaser.Images.addImage(0,20, UIAssetKeys._TitleHeader_1, this.titleHeader).setOrigin(0);
    this.titleHeader.x = this.scale.width / 2 - this.titleHeader1.width / 2;

    this.titleHeader2 = ABCyaPhaser.Images.addImage(0, this.titleHeader1.y + this.titleHeader1.height - 15, UIAssetKeys._TitleHeader_2, this.titleHeader).setOrigin(0);
    this.titleHeader2.x = this.titleHeader1.width / 2 - this.titleHeader2.width / 2;

    this.swipe = this.add.sprite(-30, this.titleHeader1.y + 40, ABCyaPhaser.Images.DEFAULT_ATLAS, 0);
    addStartAnimationToSprite(this.swipe, true);
    this.titleHeader.add(this.swipe);

    ABCyaPhaser.Tweens.addTween(this.titleHeader1, 220, { y: this.titleHeader1.y - 25 }, Phaser.Math.Easing.Quadratic.In);
    ABCyaPhaser.Tweens.addTween(this.titleHeader2, 220, { y: this.titleHeader2.y + 40 }, Phaser.Math.Easing.Quadratic.In);

    this.createButtonContainer();
    this.btnContainer.x = this.scale.width / 2 - this.btnContainer.getBounds().width / 2 - 10;

    this.titleStamp = ABCyaPhaser.Images.addImage(820, 420, 'TitleStamp', this, GAME_IMAGES_KEY).setVisible(false);

    this.time.delayedCall(400, this.showStamp, null, this);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._ninja_theme, this);
  }

  createButtonContainer() {
    this.btnContainer = this.add.container();
  }

  showStamp () {
    this.titleStamp.scale = 1.3;
    this.titleStamp.alpha = 0.8;
    this.titleStamp.setVisible(true);
    ABCyaPhaser.Tweens.addTween(this.titleStamp, 120, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} sender 
   */
  onClickOptionButton (sender) {
    gameData.gameMode = sender.optionID;

    this.scene.start(IntroScreenBase.KEY);
  }
}